<script lang="ts" setup>
	import {useI18n} from 'vue-i18n';
	import {computed, onMounted} from 'vue';
	import {type RelatedCustomer} from 'dummen-shared';
	import {storeToRefs} from 'pinia';
	import {useRelatedCustomersStore} from '@/store/related.customers.store';
	import Multiselect from 'vue-multiselect';
	import {
		getSelectedCustomer,
		setSelectedCustomer
	} from 'dummen-shared/src/services/selected.customer.storage.service.ts';

	const {t} = useI18n();

	const relatedCustomersStore = useRelatedCustomersStore();

	const {relatedCustomers} = storeToRefs(relatedCustomersStore);

	const emit = defineEmits(['on-related-customer-change']);

	defineProps<{
		required?: boolean;
	}>();

	const selectedCustomerId = computed(() => getSelectedCustomer());

	const activeRelatedCustomers = computed(() => relatedCustomers.value.filter(customer => customer.active));

	const selectedCustomer = computed(() => {
		return activeRelatedCustomers.value
			.find(customer => customer.customerId === selectedCustomerId.value);
	});

	const getLabel = (option: RelatedCustomer) => `${option.name} - ${option.customerId}`;

	const updateSelectedCustomerId = async (customer: RelatedCustomer) => {
		if (!customer) {
			return;
		}

		setSelectedCustomer(customer.customerId);

		emit('on-related-customer-change', customer.customerId);
	};

	onMounted(async () => {
		// If the selected customer does not exist or is not active, we must inform the parent component.
		if (selectedCustomerId.value && !selectedCustomer.value) {
			emit('on-related-customer-change', null);
		}
	});

</script>

<template>
	<div class="mydummen-order-overview__filter-related-customers">
		<label for="order-customer-select">
			{{ t('shoppingcart.modal.createpo.content.relatedCustomer.label') }}
		</label>

		<multiselect id="order-customer-select"
		             :custom-label="getLabel"
		             :model-value="selectedCustomer"
		             :options="activeRelatedCustomers"
		             :placeholder="t('shoppingcart.modal.createpo.content.relatedCustomer.select.text')"
		             :searchable="true"
		             :show-labels="false"
		             deselect-label=""
		             select-label=""
		             selected-label=""
		             track-by="customerId"
		             @update:model-value="updateSelectedCustomerId" />

		<p v-if="required && !selectedCustomer" class="modal-wrapper__no-selected-customer">
			{{ t('shoppingcart.modal.createpo.content.relatedCustomer.select.text') }}
		</p>
	</div>
</template>
